export function navigationScroll() {

    // Überprüfen, ob Elemente mit den gesuchten Klassen im DOM existieren
    const hasSmallHeader = document.querySelector('.vs-wrapper-header-small') !== null;
    const hasBigHeader = document.querySelector('.vs-wrapper-header-big') !== null;

    // Falls eines der Elemente existiert, Eventlistener hinzufügen
    if (hasSmallHeader || hasBigHeader) {
        // Das Navigations-Element auswählen
        const nav = document.querySelector('.vs-main-navigation');

        // Eventlistener hinzufügen
        window.addEventListener('scroll', function() {
            // Überprüfen, ob der Scroll-Wert größer oder gleich 80 ist
            if (window.scrollY >= 80) {
                // Klasse hinzufügen
                nav.classList.add('onScroll');
            } else {
                // Klasse entfernen
                nav.classList.remove('onScroll');
            }
        });


        const menuItems = document.querySelectorAll('.menu-item-has-children');

        menuItems.forEach(item => {
            item.addEventListener('mouseover', function() {
                // Hover-Effekt nur anwenden, wenn die Klasse 'onScroll' nicht vorhanden ist
                if (!nav.classList.contains('onScroll')) {
                    nav.classList.add('hover-effect');
                }
            });

            item.addEventListener('mouseout', function() {
                // Entfernen des Hover-Effekts
                nav.classList.remove('hover-effect');
            });
        });

    }
}
